import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '06a16f2f-914a-47f7-a660-c98063a9bd7e',
  clientToken: 'pubea0d38a0475de78710b1a2bae3afa804',
  site: 'datadoghq.com',
  service: 'mapistry-web-app',
  env: process.env.NODE_ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sampleRate: 100,
  sessionReplaySampleRate: 100,
  trackInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

datadogRum.startSessionReplayRecording();
